import mitt, { Emitter } from "mitt";
import { Customer, Media, PaymentMethod, PickupPoint, Product, ShippingMethod } from "@daalder/types";
import type RegisterFormProps from "../types/RegisterFormProps";

/**
 * @deprecated This should be removed and replaced with Pinia stores and such.
 * @todo: Replace all of the 'any' types with strict type definitions.
 */
export type Events = {
    loggedIn: void;
    loginUser: {
        login?: LoginFormProps;
        register?: RegisterFormProps;
        onlyShowLoginForm?: boolean;
    };
    // TODO: The purpose of the event payload should be deducible from the event name.
    openForgotPasswordModal: boolean | undefined | null;
    stepStateUpdate: any;
    customerChanged: Customer;
    customerInfoUpdated: { customer_token: string; is_guest: boolean; is_authenticated: boolean };
    imageZoomModalClosed: any;
    openImageZoomModal: { slides: Media[]; activeSlide: Number };
    toggleMobileMenu: any;
    mainMenuFetched: any;
    pledgValidationError: any;
    // TODO: Remove this
    validateInput: void;
};

/**
 * @deprecated Remove all of these events and delegate the logic to either Pinia stores or to more specific EventBusses.
 * The goal of this would be to de-clutter the logic flows and only keep strictly defined events.
 */
const GlobalEventBus: Emitter<Events> = mitt<Events>();

export default GlobalEventBus;
